import ManagerAvailabilityReport from "./ManagerAvailabilityReport.component.jsx";

export default ManagerAvailabilityReport;
